(function(){
  const dataEl = document.getElementById('recipes-data');
  if (!dataEl) return;
  const recipes = JSON.parse(dataEl.textContent);

  const search=document.getElementById('search'),grid=document.getElementById('grid'),
  count=document.getElementById('count'),empty=document.getElementById('empty'),chipsEl=document.getElementById('chips'),
  loadmoreWrap=document.getElementById('loadmoreWrap'),loadmoreBtn=document.getElementById('loadmore');
  const PAGE=6;let visible=PAGE,activeCat='';

  const cats=[...new Set(recipes.map(r=>r.cat))];
  chipsEl.innerHTML='<button class="rs-chip rs-active" data-c="">Todas</button>'+cats.map(c=>`<button class="rs-chip" data-c="${c}">${c}</button>`).join('');

  // "2:15–2:45" (mm:ss–mm:ss) -> tempo total médio formatado, ex: "≈ 2 min 30s"
  function parseMMSS(s){const [m,sec]=s.split(':').map(Number);return m*60+sec}
  function totalTime(target){
    const [a,b]=target.split('–').map(parseMMSS);
    const avg=Math.round((a+b)/2);
    const m=Math.floor(avg/60), s=avg%60;
    return {label:`${m} min${s?` ${s}s`:''}`, range:`entre ${target.split('–')[0]} e ${target.split('–')[1]} (min:seg)`};
  }

  const ICON_TIMER='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5"/><path d="M9 2h6"/></svg>';

  function cardHTML(r){
    const t=totalTime(r.target);
    return `<button class="rs-card" data-id="${r.id}">
      <div class="rs-card-top"><span class="rs-card-cat">${r.cat}</span><span class="rs-card-time">${t.label}</span></div>
      <h3>${r.name}</h3>
      <div class="rs-card-sub">Café coado · passo a passo com cronograma de despejos</div>
      <div class="rs-card-meta"><span>Dose ${r.dose}</span><span>Água ${r.agua}</span></div>
      <span class="rs-card-open">Ver receita completa →</span>
    </button>`;
  }

  function render(){
    const q=search.value.toLowerCase().trim();
    const filtered=recipes.filter(r=>(!q||r.name.toLowerCase().includes(q))&&(!activeCat||r.cat===activeCat));
    count.textContent=filtered.length+' receita'+(filtered.length===1?'':'s')+' encontrada'+(filtered.length===1?'':'s');
    empty.style.display=filtered.length?'none':'block';
    const shown=filtered.slice(0,visible);
    grid.innerHTML=shown.map(cardHTML).join('');
    loadmoreWrap.style.display=filtered.length>shown.length?'flex':'none';
    grid.querySelectorAll('.rs-card').forEach(b=>b.onclick=()=>openModal(b.dataset.id));
    chipsEl.querySelectorAll('.rs-chip').forEach(b=>b.classList.toggle('rs-active',b.dataset.c===activeCat));
  }
  search.oninput=()=>{visible=PAGE;render()};
  chipsEl.addEventListener('click',e=>{const b=e.target.closest('.rs-chip');if(!b)return;activeCat=b.dataset.c;visible=PAGE;render()});
  loadmoreBtn.onclick=()=>{visible+=PAGE;render()};

  // ===== modal centralizado =====
  const back=document.getElementById('back');
  function openModal(id){
    const r=recipes.find(x=>x.id===id); if(!r) return;
    document.getElementById('dcat').textContent=r.cat;
    document.getElementById('dtitle').textContent=r.name;
    document.getElementById('ddose').textContent=r.dose;
    document.getElementById('dagua').textContent=r.agua;
    document.getElementById('dtemp').textContent=r.temp;
    const t=totalTime(r.target);
    document.getElementById('dtarget').innerHTML=ICON_TIMER+t.label;
    document.getElementById('dtargetRange').textContent=t.range;
    document.getElementById('dproduct').textContent=r.product;
    const pours=r.pours||[], adjs=r.adjs||[];
    document.getElementById('dtimeline').innerHTML=pours.map((p,i)=>`
      <div class="rs-pour ${i===pours.length-1?'rs-pour--last':''}">
        <div class="rs-pour-time">${p[0]}</div><div class="rs-pour-rail"><span class="rs-pour-dot"></span></div>
        <div class="rs-pour-body"><span class="rs-pour-act">${p[1]}</span><span class="rs-pour-ml">${p[2]}</span></div>
      </div>`).join('');
    document.getElementById('dadjs').innerHTML=adjs.map(a=>`
      <div class="rs-adj"><span class="rs-adj-cond">${a[0]}</span><span class="rs-adj-act">${a[1]}</span></div>`).join('');
    const videoBox=document.getElementById('dvideoBox');
    if(r.video){
      videoBox.style.display='block';
      const ratioClass=r.video.type==='ig'?'rs-ratio-ig':'rs-ratio-yt';
      document.getElementById('dvideoBody').innerHTML=`
        <div class="rs-ratio ${ratioClass}"><iframe src="${r.video.src}" loading="lazy" frameborder="0" allowfullscreen></iframe></div>
        <a class="rs-video-link" href="${r.video.link}" target="_blank" rel="noopener">Assistir na íntegra</a>`;
    } else { videoBox.style.display='none'; }
    videoBox.classList.remove('rs-open');
    lockScroll();
    back.classList.add('rs-show');
    back.dataset.current=id;
    back.querySelector('.rs-modal').scrollTop=0;
  }
  document.getElementById('close').onclick=closeModal;
  back.addEventListener('click',e=>{if(e.target===back)closeModal()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeModal()});
  function lockScroll(){
    const scrollbarWidth=window.innerWidth-document.documentElement.clientWidth;
    document.body.style.overflow='hidden';
    if(scrollbarWidth>0) document.body.style.paddingRight=scrollbarWidth+'px';
  }
  function closeModal(){
    back.classList.remove('rs-show');
    document.body.style.overflow='';
    document.body.style.paddingRight='';
  }
  document.addEventListener('click',e=>{const t=e.target.closest('.rs-video-toggle');if(t)t.parentElement.classList.toggle('rs-open')});

  document.getElementById('prevRecipe').onclick=()=>step(-1);
  document.getElementById('nextRecipe').onclick=()=>step(1);
  function step(dir){
    const idx=recipes.findIndex(r=>r.id===back.dataset.current);
    const next=recipes[(idx+dir+recipes.length)%recipes.length];
    openModal(next.id);
  }

  render();
})();